export const PropertyEvaluationContext = {
    $this: '$this',
    $parent: '$parent',
    $root: '$root',
    $main: '$main'
};